import script from "./SelectorPresentacion.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectorPresentacion.vue?vue&type=script&setup=true&lang=js"

import "./SelectorPresentacion.vue?vue&type=style&index=0&id=6a79f3df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a79f3df"]])

export default __exports__